import { FC, ReactElement } from 'react';
import Theme from '../../components-library/Theme';

interface Props {
  label: string;
}

const ClosedSign: FC<Props> = ({ label }): ReactElement => {
  return (
    <div className="flex flex-col items-center">
      <div className="relative flex flex-col items-center w-full -mb-[2px]">
        <div className="h-[20px] w-[20px] bg-white rounded-full border-[3px] border-danger z-10 -mb-[10px]" />
        <div className="w-full px-lg">
          <svg
            className="w-full h-[40px]"
            viewBox="0 0 100 50"
            preserveAspectRatio="none"
            fill="none"
            stroke={Theme.color.danger}
            strokeWidth="3"
          >
            <polygon points="50,0 100,50 0,50" />
          </svg>
        </div>
      </div>
      <div className="bg-danger z-[10] min-w-[180px] text-white px-lg py-md rounded-lg text-base font-bold text-center shadow-md shadow-none">
        <h3>{label}</h3>
      </div>
    </div>
  );
};

export default ClosedSign;
